<template>
    <div class="data_box">
        <div class="detail">
            <div class="detail_box" v-if="currentRecord">
                <div class="column">
                    <div class="name">风速</div>
                    <div class="text">{{ currentRecord.wind_speed / 10 || '0' }}m/s</div>
                </div>
                <div class="column">
                    <div class="name">当前载重</div>
                    <div class="text">{{ currentRecord.load || '0' }}kg</div>
                </div>
                <div class="column">
                    <div class="name">高度</div>
                    <div class="text">{{ currentRecord.height / 10 || '0' }}m</div>
                </div>
                <div class="column">
                    <div class="name">幅度</div>
                    <div class="text">{{ currentRecord.amplitude / 10 || '0' }}m</div>
                </div>
                <div class="column">
                    <div class="name">回转</div>
                    <div class="text">{{ currentRecord.rotation / 10 || '0' }}°</div>
                </div>
                <div class="column">
                    <div class="name">力矩百分比</div>
                    <div class="text">{{ currentRecord.torque_percentage || '0' }}%</div>
                </div>
                <div class="column">
                    <div class="name">倾角</div>
                    <div class="text">{{ currentRecord.tilt || '0' }}°</div>
                </div>
            </div>
        </div>
        <div class="video_box">
            <div class="box_title">
                <div class="title">塔吊可视化</div>
                <div class="box_btn"><button class="add_btn" @click="isShowVideoList = true">编辑</button></div>
            </div>
            <div class="video_cont">
                <div class="control">
                    <div class="btn" :class="videoInfo && videoInfo.quality == 1 ? 'active' : ''" @click="fnChangeOneQuality('1')">标清</div>
                    <div class="btn" :class="videoInfo && videoInfo.quality == 2 ? 'active' : ''" @click="fnChangeOneQuality('2')">高清</div>
                </div>
                <video
                    class="video"
                    v-if="(videoInfo && videoInfo.liveAddress) || (videoInfo && videoInfo.hdAddress)"
                    id="player_one"
                    :src="videoInfo.quality == 1 ? videoInfo.liveAddress : videoInfo.hdAddress"
                    controls
                    playsInline
                    webkit-playsinline
                ></video>
                <img class="img" v-else src="../../../../assets/img/no.png" />
            </div>
        </div>
        <div class="figure">
            <div class="anchor" :style="{ left: anchorLeft + '%' }">
                <div class="target" :style="{ height: targetHeight + 'px' }">
                    <div class="string"></div>
                    <div class="hook"></div>
                </div>
            </div>
        </div>
        <div class="indicator">
            <div class="today">
                <div class="title">今日数据统计</div>
                <div class="con">
                    <div class="con_box">
                        <div class="box_title">预报警</div>
                        <div class="box_count">
                            <span>{{ warningCount }}</span>
                            次
                        </div>
                        <div class="box_btn"><button class="add_btn" @click="fnOpenAlarmWin">查看详情</button></div>
                    </div>
                    <div class="con_box">
                        <div class="box_title">装载次数</div>
                        <div class="box_count">
                            <span>{{ cycleCount }}</span>
                            次
                        </div>
                        <div class="box_btn"><button class="add_btn" @click="fnOpenHoistingRecordWin">查看详情</button></div>
                    </div>
                </div>
            </div>
            <div class="security">
                <div class="title">安全统计</div>
                <div class="con"><div class="safety-rate" id="safety-rate-chart" ref="safetyRate"></div></div>
            </div>
        </div>
        <div class="elevator_chart">
            <div id="elevator-chart" class="chart-container" ref="container"></div>
            <div class="open-dateils"><button @click="fnOpenRealTimeWin" class="add_btn">查看详情</button></div>
        </div>
        <div class="dialog_selectVideo" v-if="isShowVideoList">
            <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="选择可视化塔吊" :visible.sync="isShowVideoList" center>
                <div class="cont_list">
                    <div class="list_title">
                        <div class="title_item">选择</div>
                        <div class="title_item">通道名</div>
                        <div class="title_item">通道封面</div>
                    </div>
                    <div class="list_boxes">
                        <div class="list_box">
                            <div v-if="monitorList">
                                <div class="box_line" v-for="(item, index) in monitorList" :key="index">
                                    <div class="list_item"><div class="select" @click="fnSelectChanel(index, item)" :class="item.selected ? 'active' : ''"></div></div>
                                    <div class="list_item">{{ item.name ? item.name : '未命名' }}</div>
                                    <div class="list_item"><img :src="item.cover || 'http://cqxtkj.oss-cn-chengdu.aliyuncs.com/image/40fd31b9434de0d6cc965f1c2b475368.jpg'" /></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <div class="btn_line">
                        <div class="search-btn red" @click="isShowVideoList = false"><span>取消</span></div>
                        <div class="search-btn" @click="fnSavaVideo"><span>确定</span></div>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import echarts from 'echarts';
require('echarts/theme/macarons'); // echarts theme
import request from '@/utils/request';
import APP from '@/utils/base';
import EZUIKit from '../../../../../static/ezuikit';
import { getUserInfo } from '@/utils/auth';
export default {
    props: {
        currentCrane: {
            type: Object
        }
    },
    data() {
        return {
            timer: null,
            safetyRateChart: null,
            elevatorChart: null,
            currentRecord: {}, // 设备当前最新一条实时记录
            warningCount: 0, // 预报警条数统计
            cycleCount: 0, // 吊装条数统计
            recordCount: 1, // 记录条数统计
            safetyRate: 100, // 安全统计
            chartDataX: [], // 统计图X轴数据
            heightY: [], // 统计图Y轴高度数据
            amplitudeY: [], // 统计图Y轴幅度数据
            loadY: [], // 统计图Y轴载重数据
            windSpeedY: [], // 统计图Y轴风速数据
            tiltY: [], // 统计图Y轴倾角数据
            rotationY: [], // 统计图Y轴回转数据
            craneArmLength: 0, // 当前塔机臂长
            craneHeight: 0, // 当前塔机高度
            targetHeight: 60,
            anchorLeft: 34,
            currentCraneNew: {
                eqptStatus: '',
                number: '',
                id: '',
                nowTime: ''
            },
            player_one: null, // 萤石云初始化 1 宫格
            videoInfo: null,
            monitorList: [],
            deviceSerial: null,
            isShowVideoList: false,
            selectedVideo: null,
            craneExtendInfo: null
        };
    },
    created() {
        this.fnGetMonitorList();
        this.fnGetChartData();
        this.fnGetTodayRecord();
        this.fnGetCraneExtend();
        this.timer = setInterval(() => {
            this.fnGetChartData();
            this.fnGetTodayRecord();
        }, 120000);
    },
    watch: {
        currentCrane: {
            handler: function(newV, oldV) {
                if (oldV && newV) {
                    if (newV.number !== oldV.number) {
                        clearInterval(this.timer);
                        this.timer = setInterval(() => {
                            this.fnGetCraneExtend();
                            this.fnGetChartData();
                            this.fnGetLatestRecord();
                            this.fnGetTodayRecord();
                        }, 120000);
                    }
                    if (newV.nowTime >= oldV.nowTime) {
                        this.fnGetCraneExtend();
                        this.fnGetChartData();
                        this.fnGetLatestRecord();
                        this.fnGetTodayRecord();
                    }
                }
                if (newV === undefined) {
                    this.currentCraneNew = {
                        eqptStatus: '',
                        number: '',
                        id: '',
                        nowTime: ''
                    };
                } else {
                    this.currentCraneNew.eqptStatus = newV.eqptStatus;
                    this.currentCraneNew.number = newV.number;
                    this.currentCraneNew.id = newV.id;
                    this.currentCraneNew.nowTime = newV.nowTime;
                    this.fnGetCraneExtend();
                    this.fnGetChartData();
                    this.fnGetLatestRecord();
                    this.fnGetTodayRecord();
                }
            },
            immediate: true,
            deep: true
        }
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
    methods: {
        // 获取视频监控列表
        fnGetMonitorList() {
            request({
                url: 'zgj-monitor/getMonitorList',
                methods: 'GET'
            })
                .then(res => {
                    if (res.code == 1) {
                        let _data = res.data;
                        let _arr = [];
                        let _editObj = [];
                        for (let i in _data) {
                            let _deviceSerial = _data[i].deviceSerial;
                            // let _id = _data[i].id
                            let _channel = _data[i].channel ? JSON.parse(_data[i].channel) : {};
                            for (let j in _channel) {
                                // _channel[j].deviceSerialId = _id
                                _channel[j].deviceSerial = _deviceSerial;
                                _arr.push(_channel[j]);
                            }
                        }
                        for (let i in _arr) {
                            let _index1 = _arr[i].liveAddress.lastIndexOf(':');
                            _arr[i].liveAddress = 'https' + _arr[i].liveAddress.slice(_index1);
                            let _index2 = _arr[i].hdAddress.lastIndexOf(':');
                            _arr[i].hdAddress = 'https' + _arr[i].hdAddress.slice(_index2);
                            _arr[i].quality = '1';
                            _arr[i].selected = false;
                        }
                        this.monitorList = _arr;
                    }
                })
                .catch(err => {
                    this.$message.error(err);
                });
        },
        // 编辑 选择 可视化塔吊通道
        fnSelectChanel(_index, _item) {
            for (let i = 0; i < this.monitorList.length; i++) {
                this.monitorList[i].selected = false;
            }
            this.monitorList[_index].selected = true;
            this.selectedVideo = {
                channelNo: this.monitorList[_index].channelNo,
                deviceSerial: this.monitorList[_index].deviceSerial
            };
        },
        // 保存 设置的 可视化
        fnSavaVideo() {
            this.craneExtendInfo.visualization = this.selectedVideo;
            let _obj = JSON.parse(JSON.stringify(this.craneExtendInfo));
            request({
                url: 'crane/edit',
                method: 'POST',
                data: {
                    id: this.currentCraneNew.id,
                    project_id: getUserInfo().id,
                    extend: JSON.stringify(_obj)
                }
            })
                .then(res => {
                    if (res.code == 1) {
                        this.$message.success(res.data);
                        this.fnGetCraneExtend();
                        this.isShowVideoList = false;
                    }
                })
                .catch(err => {
                    this.$message.error(err);
                });
        },
        // 视频初始化
        fnInitVideo() {
            if (this.player_one) {
                this.player_one.stop();
                this.player_one = null;
            }
            if (this.craneExtendInfo && this.craneExtendInfo.visualization) {
                for (let i in this.monitorList) {
                    if (
                        this.monitorList[i].channelNo == this.craneExtendInfo.visualization.channelNo &&
                        this.monitorList[i].deviceSerial == this.craneExtendInfo.visualization.deviceSerial
                    ) {
                        this.videoInfo = this.monitorList[i];
                    }
                }
                if (this.videoInfo) {
                    this.$nextTick(() => {
                        this.player_one = new EZUIKit.EZUIPlayer('player_one');
                        this.player_one.play();
                    });
                }
            }
        },
        // 切换高标清
        fnChangeOneQuality(quality) {
            this.videoInfo.quality = quality;
            this.$nextTick(() => {
                this.player_one = new EZUIKit.EZUIPlayer('player_one');
                this.player_one.play();
            });
        },
        chartResize() {
            this.elevatorChart.resize();
        },
        // 查看预报警记录
        fnOpenAlarmWin() {
            this.$parent.fnOpenCraneAlarm();
        },
        // 查看吊装记录
        fnOpenHoistingRecordWin() {
            this.$parent.fnOpenHoistingRecord();
        },
        // 查看运行记录
        fnOpenRealTimeWin() {
            this.$parent.fnOpenCraneRealTimeRecord();
        },
        // 查看塔机运行记录
        fnOpenCraneRecord() {
            this.$parent.fnOpenCraneRealTimeRecord();
        },
        // 塔机统计图初始化
        fnCraneChart() {
            this.elevatorChart = echarts.init(this.$refs.container);
            this.elevatorChart.setOption({
                backgroundColor: 'rgba(29,68,149,.1)',
                title: {
                    top: 20,
                    text: '运行记录',
                    textStyle: {
                        fontWeight: 'normal',
                        fontSize: 16,
                        color: '#F1F1F3'
                    },
                    left: '1%'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        lineStyle: {
                            color: '#57617B'
                        }
                    }
                },
                legend: {
                    top: '20px',
                    textStyle: {
                        color: '#fff'
                    },
                    data: ['高度', '幅度', '载重', '风速', '倾角']
                },
                grid: {
                    top: 100,
                    left: '2%',
                    right: '2%',
                    bottom: '2%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        boundaryGap: false,
                        axisLine: {
                            lineStyle: {
                                color: '#fff'
                            }
                        },
                        data: this.chartDataX
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '',
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#fff'
                            }
                        },
                        axisLabel: {
                            margin: 10,
                            textStyle: {
                                fontSize: 14
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#57617B'
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: '高度',
                        type: 'line',
                        smooth: true,
                        symbol: 'circle',
                        symbolSize: 5,
                        showSymbol: false,
                        lineStyle: {
                            normal: {
                                width: 2
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: 'rgb(137,189,27)',
                                borderColor: 'rgba(137,189,2,0.27)',
                                borderWidth: 12
                            }
                        },
                        data: this.heightY
                    },
                    {
                        name: '幅度',
                        type: 'line',
                        smooth: true,
                        symbol: 'circle',
                        symbolSize: 5,
                        showSymbol: false,
                        lineStyle: {
                            normal: {
                                width: 2
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: '#fff',
                                borderColor: 'rgba(137,189,2,0.27)',
                                borderWidth: 12
                            }
                        },
                        data: this.amplitudeY
                    },
                    {
                        name: '载重',
                        type: 'line',
                        smooth: true,
                        symbol: 'circle',
                        symbolSize: 5,
                        showSymbol: false,
                        lineStyle: {
                            normal: {
                                width: 2
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: '#F56C6C',
                                borderColor: 'rgba(137,189,2,0.27)',
                                borderWidth: 12
                            }
                        },
                        data: this.loadY
                    },
                    {
                        name: '风速',
                        type: 'line',
                        smooth: true,
                        symbol: 'circle',
                        symbolSize: 5,
                        showSymbol: false,
                        lineStyle: {
                            normal: {
                                width: 2
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: '#909399',
                                borderColor: 'rgba(137,189,2,0.27)',
                                borderWidth: 12
                            }
                        },
                        data: this.windSpeedY
                    },
                    {
                        name: '倾角',
                        type: 'line',
                        smooth: true,
                        symbol: 'circle',
                        symbolSize: 5,
                        showSymbol: false,
                        lineStyle: {
                            normal: {
                                width: 2
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: '#409EFF',
                                borderColor: 'rgba(137,189,2,0.27)',
                                borderWidth: 12
                            }
                        },
                        data: this.tiltY
                    }
                ]
            });
        },
        // 安全运行率统计
        fnSafetyRateChart() {
            this.safetyRateChart = echarts.init(this.$refs.safetyRate);
            this.safetyRateChart.setOption({
                title: {
                    text: '安全运行率',
                    left: '20px',
                    textStyle: {
                        color: '#fff'
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)'
                },
                legend: {
                    orient: 'vertical',
                    x: 'left',
                    show: false,
                    data: ['安全运行率', '错误数量']
                },
                series: [
                    {
                        name: '安全统计',
                        type: 'pie',
                        radius: ['50%', '70%'],
                        avoidLabelOverlap: false,
                        label: {
                            normal: {
                                position: 'center'
                            },
                            emphasis: {
                                show: true,
                                textStyle: {
                                    fontSize: '16',
                                    fontWeight: 'bold'
                                }
                            }
                        },
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        data: [
                            {
                                value: this.recordCount - this.warningCount,
                                itemStyle: { color: '#ECC64D' },
                                name: '安全运行率'
                            },
                            { value: this.warningCount, label: { show: false }, name: '错误数量' }
                        ]
                    }
                ]
            });
        },
        // 获取塔机实时数据记录公共方法
        fnGetCraneRecord(_obj, _cb) {
            request({
                notLoading: true,
                url: 'crane/getRecord',
                method: 'GET',
                params: _obj
            })
                .then(res => {
                    _cb && _cb(res.data);
                })
                .catch(err => {
                    this.currentRecord = {};
                });
        },
        // 获取最新一条塔机实时记录
        fnGetLatestRecord() {
            if (!this.currentCraneNew.number) return;
            this.fnGetCraneRecord(
                {
                    number: this.currentCraneNew.number,
                    page: 1,
                    size: 1
                },
                res => {
                    this.currentRecord = res.query[0];
                    this.$nextTick(() => {
                        this.fnSafetyRateChart();
                        this.fnCraneRunTime();
                    });
                }
            );
        },
        // 获取塔机当天实时记录
        fnGetTodayRecord() {
            if (!this.currentCraneNew.number) return;
            let _that = this;
            let _myDate = new Date().Format('yyyy-MM-dd');
            let _startTime = _myDate + ' 00:00:00';
            let _endTime = _myDate + ' 23:59:59';
            let _createAt = _startTime + ',' + _endTime;
            let _recordArr = [];
            let _cycleArr = [];
            let _recordPage = 1;
            let _cyclePage = 1;
            let _size = 50;
            let _warning = 0; // 预报警信息统计
            let _cycle = 0; // 吊装记录统计
            _fnGetCycle(() => {
                _fnGetRecord(() => {
                    request({
                        url: 'crane/getRecord',
                        method: 'GET',
                        params: {
                            number: _that.currentCraneNew.number,
                            page: 1,
                            size: 1,
                            create_at: _createAt,
                            is_alarm: 1
                        }
                    }).then(res => {
                        _that.warningCount = res.data.count;
                        _that.fnSafetyRateChart();
                    });
                });
            });

            // 获取吊装记录、实时记录总条数
            function _fnGetCycle(_cb) {
                request({
                    url: 'crane/getCycle',
                    method: 'GET',
                    params: {
                        number: _that.currentCraneNew.number,
                        page: 1,
                        size: 1,
                        create_at: _createAt
                    }
                })
                    .then(res => {
                        _that.cycleCount = res.data.count;
                        _cb && _cb();
                    })
                    .catch(err => {
                        _cb && _cb();
                    });
            }

            // 获取实时记录总条数
            function _fnGetRecord(_cb) {
                request({
                    url: 'crane/getRecord',
                    method: 'GET',
                    params: {
                        number: _that.currentCraneNew.number,
                        page: 1,
                        size: 1,
                        create_at: _createAt
                    }
                })
                    .then(result => {
                        _that.recordCount = result.data.count ? result.data.count : 1;
                        _cb && _cb();
                    })
                    .catch(err => {
                        _that.recordCount = 1;
                        _cb && _cb();
                    });
            }
        },
        // 获取塔机统计图数据
        fnGetChartData() {
            if (!this.currentCraneNew.number) {
                let _myDate = new Date().getTime();
                let _index = 0;
                let _dataX = [];
                let _heightY = [];
                let _amplitudeY = [];
                let _loadY = [];
                let _windSpeedY = [];
                let _tiltY = [];
                while (_index < 20) {
                    _myDate -= 1000 * 10;
                    _dataX.unshift(new Date(_myDate).Format('hh:mm:ss'));
                    _heightY.unshift(0);
                    _amplitudeY.unshift(0);
                    _loadY.unshift(0);
                    _windSpeedY.unshift(0);
                    _tiltY.unshift(0);
                    _index++;
                }
                this.chartDataX = _dataX;
                this.heightY = _heightY;
                this.amplitudeY = _amplitudeY;
                this.loadY = _loadY;
                this.windSpeedY = _windSpeedY;
                this.tiltY = _tiltY;
                this.$nextTick(() => {
                    this.fnCraneChart();
                });
                return;
            }
            request({
                notLoading: true,
                url: 'crane/getRecord',
                method: 'GET',
                params: {
                    number: this.currentCraneNew.number,
                    page: 1,
                    size: 20
                }
            })
                .then(res => {
                    this.currentRecord = res.data.query[0];
                    let _data = res.data.query;
                    let _dataX = [];
                    let _heightY = [];
                    let _amplitudeY = [];
                    let _loadY = [];
                    let _windSpeedY = [];
                    let _tiltY = [];
                    this.fnSafetyRateChart();
                    this.fnCraneRunTime();
                    _data.forEach(_item => {
                        _dataX.unshift(_item.record_at.split(' ')[1]);
                        _heightY.unshift(_item.height / 10);
                        _amplitudeY.unshift(_item.amplitude / 10);
                        _loadY.unshift(_item.load);
                        _windSpeedY.unshift(_item.wind_speed / 10);
                        _tiltY.unshift(_item.tilt / 100);
                    });
                    this.chartDataX = _dataX;
                    this.heightY = _heightY;
                    this.amplitudeY = _amplitudeY;
                    this.loadY = _loadY;
                    this.windSpeedY = _windSpeedY;
                    this.tiltY = _tiltY;
                    this.$nextTick(() => {
                        this.fnCraneChart();
                    });
                })
                .catch(err => {
                    let _myDate = new Date().getTime();
                    let _index = 0;
                    let _dataX = [];
                    let _heightY = [];
                    let _amplitudeY = [];
                    let _loadY = [];
                    let _windSpeedY = [];
                    let _tiltY = [];
                    while (_index < 20) {
                        _myDate -= 1000 * 10;
                        _dataX.unshift(new Date(_myDate).Format('hh:mm:ss'));
                        _heightY.unshift(0);
                        _amplitudeY.unshift(0);
                        _loadY.unshift(0);
                        _windSpeedY.unshift(0);
                        _tiltY.unshift(0);
                        _index++;
                    }
                    this.chartDataX = _dataX;
                    this.heightY = _heightY;
                    this.amplitudeY = _amplitudeY;
                    this.loadY = _loadY;
                    this.windSpeedY = _windSpeedY;
                    this.tiltY = _tiltY;
                    this.$nextTick(() => {
                        this.fnCraneChart();
                    });
                });
        },
        // 获取塔机扩展信息
        fnGetCraneExtend() {
            if (!this.currentCraneNew.id) return;
            request({
                url: 'crane/getExtend',
                method: 'GET',
                params: {
                    id: this.currentCraneNew.id
                }
            })
                .then(res => {
                    if (res.code == 1) {
                        this.craneExtendInfo = res.data;
                        this.fnInitVideo();
                    }
                    if (res.data && res.data.eqptParameter) {
                        this.craneArmLength = res.data.eqptParameter.craneArmLength;
                        this.craneHeight = res.data.eqptParameter.craneArmHeight;
                    } else {
                        this.craneArmLength = 0;
                        this.craneHeight = 0;
                    }
                    this.fnCraneRunTime();
                })
                .catch(err => {
                    this.craneArmLength = 0;
                    this.craneHeight = 0;
                    this.fnCraneRunTime();
                });
        },
        // 计算塔机运行高度、幅度
        fnCraneRunTime() {
            let _that = this;
            if (_that.craneArmLength) {
                let _length = 34;
                _length += (_that.currentRecord.amplitude / _that.craneArmLength) * 72;
                if (_length > 77) {
                    _length = 77;
                }
                _that.anchorLeft = _length;
            } else {
                _that.anchorLeft = 34;
            }
            if (_that.craneHeight) {
                let _height = 0;
                _height = (_that.craneHeight - _that.currentRecord.height) / _that.craneHeight;
                _height = 60 + 300 * _height;
                if (!_height) {
                    _height = 60;
                }
                _that.targetHeight = _height;
            } else {
                _that.targetHeight = 60;
            }
        }
    },
    mounted() {
        window.addEventListener('resize', this.chartResize);
    }
};
</script>

<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
.data_box{
	width: 1600px;
	height: 778px;
	position: relative;
}
.detail {
	position: absolute;
	left: 40px;
	top: 0;
	.detail_box {
		width: 280px;
		background: rgba(29, 68, 149, 0.1);
		border-radius: 5px;
		box-shadow: 3px 3px 5px #042233;
		padding: 2px 10px;
		line-height: 40px;
		font-size: 18px;
		.column {
			@include flex-box();
			.name {
				@include flex-item();
				color: #42b89d;
			}
			.text {
				color: #fff;
			}
		}
	}
}
.video_box{
    position: absolute;
    z-index: 999px;
    left: 40px;
    top: 430px;
    width: 400px;
    height: 350px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    background: rgba(29, 68, 149, 0.1);
    border-radius: 5px;
    box-shadow: 3px 3px 5px #042233;
    @include flex-box($direction: column);
    .box_title{
        width: 400px;
        height: 50px;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        background: url(../../../../assets/img/per_list_bg.png) no-repeat;
        background-size: 100% 100%;
        padding: 0 10px;
        font-size: 20px;
        @include flex-box(space-between,center);
        .box_btn{
            width: 85px;
            height: 50px;
            @include flex-box(center,center);
            .add_btn {
                width: 85px;
                height: 32px;
                line-height: 32px;
                margin: 0 2px;
                font-size: 14px;
                color: #ffffff;
                border: none;
                cursor: pointer;
                background: url(../../../../assets/img/btn_bg_osm.png) no-repeat;
                background-size: 100% 100%;
                @include flex-box(center, center);
                span {
                    margin-top: -2px;
                }
            }
        }
    }
    .video_cont{
        width: 400px;
        height: 300px;
        position: relative;
        overflow: hidden;
        .control{
          position: absolute;
          top: 0;
          right: 0;
          cursor: pointer;
          width: 100px;
          height: 35px;
          z-index: 10;
          font-size: 16px;
          font-family: "宋体";
          background-color: rgba(0,0,0,0.2);
          @include flex-box(space-between,flex-start);
          .btn{
            width: 50px;
            height: 35px;
            cursor: pointer;
            @include flex-box(center,center);
            &.active{
              color:#FFA500;
              font-size: 18px;
            }
          }
        }
        .video{
            width: 400px;
            height: 300px;
        }
        .img{
            width: 400px;
            height: 300px;
        }
    }
}
.figure{
	position: absolute;
	left: 360px;
	width: 880px;
	height: 500px;
	background: url('http://cqxtkj.oss-cn-chengdu.aliyuncs.com/image/fd6d402300ae2975c230ba93f93369dc.png') no-repeat;
	background-position: center center;
	background-size: 65% 90%;
	.anchor {
		position: absolute;
		top: 18%;
		left: 34%;
		width: 6%;
		height: 5%;
		background: url('../../../../assets/images/icon-tower-weight.png') no-repeat;
		background-position: 50% 0;
		@include prefixCss3(transition, left 0.5s);

		.target {
			position: absolute;
			width: 100%;
			height: 60px;
			overflow: hidden;
			@include prefixCss3(transition, height 1s);

			.string {
				position: absolute;
				bottom: 40px;
				left: 50%;
				width: 14px;
				height: 100%;
				border-left: 2px solid #117cd0;
				border-right: 2px solid #117cd0;
				@include prefixCss3(transform, translateX(-50%));
			}

			.hook {
				position: absolute;
				bottom: 0;
				left: 55%;
				width: 32px;
				height: 50px;
				@include prefixCss3(transform, translateX(-50%));
				background-image: url('../../../../assets/images/icon-tower-hook.png');
			}
		}
	}
}
.indicator{
	position: absolute;
	left: 1280px;
	width: 320px;
	height: 500px;
	@include flex-box(center,center,column);
	.today,.security{
		width: 320px;
		height: 240px;
		border-top-left-radius: 10px;
		border-top-right-radius: 10px;
		margin-bottom: 10px;
		@include flex-box(center,center,column);
		.title{
			width: 320px;
			height: 50px;
			border-top-left-radius: 10px;
			border-top-right-radius: 10px;
			font-size: 24px;
			color: #fefefe;
			background: url(../../../../assets/img/per_list_bg.png) no-repeat;
			background-size: 100% 100%;
			@include flex-box(center,center);
		}
		.con{
			width: 320px;
			height: 190px;
			background-color: rgba(29, 68, 149, 0.1);
			position: relative;
			@include flex-box(space-around,center);
			.con_box{
				width: 160px;
				height: 190px;
				font-size: 16px;
				@include flex-box(center,center,column);
				&:nth-child(1){
					border-right: 1px dashed #1d4495;
				}
				.box_title{
					width: 160px;
					height: 70px;
					font-size: 22px;
					@include flex-box(center,center);
				}
				.box_count{
					width: 160px;
					height: 70px;
					@include flex-box(center,center);
					span{
						color: #E03E2D;
						font-size: 32px;
						margin: 0 5px;
					}
				}
				.box_btn{
					width: 160px;
					height: 50px;
					@include flex-box(center,center);
					.add_btn {
						width: 85px;
						height: 32px;
						line-height: 32px;
						margin: 0 2px;
						font-size: 14px;
						color: #ffffff;
						border: none;
						cursor: pointer;
						background: url(../../../../assets/img/btn_bg_osm.png) no-repeat;
						background-size: 100% 100%;
						@include flex-box(center, center);

						span {
							margin-top: -2px;
						}
					}
				}
			}
			.safety-rate {
				position: absolute;
				width: 320px;
				height: 170px;
				@include flex-box(center,center);
			}
		}
	}
}
.elevator_chart{
	width: 1140px;
	height: 278px;
	position: absolute;
	top: 520px;
	left: 460px;
	.open-dateils {
		position: absolute;
		right: 30px;
		top: 20px;
		.add_btn {
			width: 85px;
			height: 32px;
			line-height: 32px;
			margin: 0 2px;
			font-size: 14px;
			color: #ffffff;
			border: none;
			cursor: pointer;
			background: url(../../../../assets/img/btn_bg_osm.png) no-repeat;
			background-size: 100% 100%;
			@include flex-box(center, center);
			span {
				margin-top: -2px;
			}
		}
	}
	.chart-container {
		position: relative;
		height: 260px;
		cursor: pointer;
	}
}
.dialog_selectVideo{
    .btn_line {
		@include flex-box(center, center);
	}
    >>> .el-dialog {
    	width: 620px;
    	height: 650px;
        background-color: rgba(9, 17, 32, 1);
        border: 1px solid rgba(58, 116, 221, 1);
    }
    >>> .el-dialog__body{
        padding: 10px;
    }
    >>> .el-form-item__label {
    	color: #4db4f4;
    }
    >>> .el-dialog__title {
    	color: #4db4f4;
    }
    >>> .el-dialog__close {
    	color: #4db4f4;
    }
    .cont_list {
    	width: 600px;
    	height: 510px;
    	color: #ffffff;
    	font-size: 16px;
    	border-radius: 10px;
    	margin: 0;
    	background-color: rgba(29, 68, 149, 0.1);
    	.list_title {
    		width: 600px;
    		height: 48px;
    		background: url(../../../../assets/img/per_list_bg.png) no-repeat;
    		background-size: 100% 100%;
    		@include flex-box(flex-start, center);
    		.title_item {
    			height: 48px;
    			@include flex-box(center, center);
    			&:nth-child(1) {
    				width: 56px;
    				margin: 0 4px 0 30px;
    			}
    			&:nth-child(2) {
    				width: 236px;
    				margin-right: 4px;
    			}
    			&:nth-child(3) {
    				width: 240px;
                    margin-right: 30px;
    			}
    			.select {
    				width: 20px;
    				height: 20px;
    				border: 1px solid #65a6dd;
    				border-radius: 2px;
    				cursor: pointer;
    				@include prefixCss3(transition, border-color 0.2s);
    				&:hover {
    					border-color: #409eff;
    				}
    				&.active {
    					background-color: #409eff;
    					border-color: #409eff;
    					&::after {
    						content: '';
    						display: block;
    						width: 100%;
    						height: 100%;
    						@include set-bg-img('../../../../assets/images/icon-yes.png');
    					}
    				}
    			}
    		}
    	}
    	.list_boxes {
    		width: 540px;
    		height: 450px;
    		margin-left: 30px;
    		position: relative;
    		overflow: hidden;
    		.list_box {
    			position: absolute;
    			left: 0;
    			right: -25px;
    			top: 0;
    			bottom: 0;
    			overflow-x: hidden;
    			overflow-y: auto;
    			.box_line {
    				width: 800px;
    				height: 110px;
    				margin: 5px 0 0 0px;
    				border-bottom: 1px dashed #1d4495;
    				@include flex-box(flex-start, center);
    				&:hover{
    					background-color: rgba(49, 88, 128, 0.4);
    				}
    				.list_item {
    					height: 100px;
    					text-align: center;
    					@include flex-box(center, center);
    					&:nth-child(1) {
    						width: 56px;
    						margin-right: 4px;
    					}
    					&:nth-child(2) {
    						width: 236px;
    						margin-right: 4px;
    					}
    					&:nth-child(3) {
    						width: 240px;
    					}
                        img{
                            width: 100px;
                            height: 100px;
                            border-radius: 8px;
                        }
    					.select {
    						width: 20px;
    						height: 20px;
    						border: 1px solid #65a6dd;
    						border-radius: 2px;
    						cursor: pointer;
    						@include prefixCss3(transition, border-color 0.2s);
    						&:hover {
    							border-color: #409eff;
    						}
    						&.active {
    							background-color: #409eff;
    							border-color: #409eff;
    							&::after {
    								content: '';
    								display: block;
    								width: 100%;
    								height: 100%;
    								@include set-bg-img('../../../../assets/images/icon-yes.png');
    							}
    						}
    					}
    				}
    			}
    		}
    	}
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Tower/towerDefault/components/Data.vue